import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'clearBtn', 'summary']

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    
    if (query.length > 0) {
      this.clearBtnTarget.classList.remove('hidden')
      this.performSearch(query)
    } else {
      this.clear()
    }
  }

  performSearch(query) {
    let matchCount = 0
    const allProjects = document.querySelectorAll('.index-item.project')
    
    allProjects.forEach(project => {
      const title = project.querySelector('.item-title')?.textContent.toLowerCase() || ''
      const tasks = project.querySelectorAll('.next-task-title')
      let taskMatch = false
      
      tasks.forEach(task => {
        if (task.textContent.toLowerCase().includes(query)) {
          taskMatch = true
        }
      })
      
      if (title.includes(query) || taskMatch) {
        project.style.display = ''
        project.classList.add('search-match')
        matchCount++
      } else {
        project.style.display = 'none'
        project.classList.remove('search-match')
      }
    })
    
    this.summaryTarget.textContent = `Found ${matchCount} project${matchCount !== 1 ? 's' : ''}`
    this.summaryTarget.classList.remove('hidden')
  }

  clear() {
    this.inputTarget.value = ''
    this.clearBtnTarget.classList.add('hidden')
    this.summaryTarget.classList.add('hidden')
    
    const allProjects = document.querySelectorAll('.index-item.project')
    allProjects.forEach(project => {
      project.style.display = ''
      project.classList.remove('search-match')
    })
  }
}
